import SMmsg from "./SMmsg";
import HMmsg from "./HMmsg";
import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { motion, useAnimation } from "framer-motion/dist/framer-motion";
import { useInView } from "react-intersection-observer";

const squareVariants = {
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: "linear" },
  },
  hidden: { opacity: 0, y: +10, transition: { duration: 0.3, ease: "linear" } },
  exit: { opacity: 0, y: 0, transition: { duration: 0.3, ease: "linear" } },
};

const Message = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (inView && !shown) {
      controls.start("visible");
      setShown(true);
    } else if (!inView && shown) {
      controls.start("exit");
      setShown(false);
    } else {
      controls.start("hidden");
      setShown(false);
    }
    // eslint-disable-next-line
  }, [controls, inView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0">
        <div className="stickyRowHeaders col-lg-6 col-12 d-flex align-items-center justify-content-center  bg-color-gr ">
          <div className="d-lg-none d-inline">
            <div>Message from Cofounders</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-180, 80]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Message from Cofounders</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-6 col-12 text-start color-dk-dark line-height-lg px-0  bg-color-w messageRow">
          <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={squareVariants}
          >
            <SMmsg />
          </motion.div>

          <motion.div
            animate={controls}
            initial="hidden"
            variants={squareVariants}
          >
            <HMmsg />
          </motion.div>

          {/* <HMmsg /> */}
        </div>
      </div>
    </div>
  );
};

export default Message;
